import { render, staticRenderFns } from "./PageWelcome.vue?vue&type=template&id=54a73b92&scoped=true&"
import script from "./PageWelcome.vue?vue&type=script&lang=js&"
export * from "./PageWelcome.vue?vue&type=script&lang=js&"
import style0 from "./PageWelcome.vue?vue&type=style&index=0&id=54a73b92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a73b92",
  null
  
)

export default component.exports